module.exports = __webpack_public_path__ + "Earth_logo_path.svg";